<template>
  <v-col class="" style="position: relative;">
    <v-row
      no-gutters
      class="px-8"
      style="position: absolute; top: 0; left: 0px; right: 0px; bottom: 0; overflow-y: auto;"
    >
      <v-col
        cols="12"
        class="px-md-6 px-sm-3 pt-6"
        :style="
          `overflow-y: auto;
                overflow-x: hidden;
                padding-bottom: 200px;
                padding-top: ${$vuetify.breakpoint.smAndUp ? '0px;' : '0px'}`
        "
      >
        <context-list-section
          icon="star"
          :contexts="activeContexts"
          :showFolderName="true"
          sectionTitle="Active"
        ></context-list-section>
        <context-list-section
          icon="schedule"
          :contexts="recentContexts"
          :showFolderName="true"
          sectionTitle="Recent"
        ></context-list-section>
        <overview-folder-contexts
          v-for="folder in sortedFolders"
          :folder="folder"
          :key="folder.id"
        ></overview-folder-contexts>
      </v-col>
    </v-row>
  </v-col>
</template>

<script>
import useUserSummary from '@/store/useUserSummary';
import ContextListSection from './ContextListSection';
import OverviewFolderContexts from './OverviewFolderContexts';

import { computed } from '@vue/composition-api';

export default {
  components: { ContextListSection, OverviewFolderContexts },
  setup() {
    const recentContexts = computed(() => {
      return useUserSummary().filterContexts({
        limit: 9,
        sortBy: 'lastOpened'
      }).value;
    });

    const activeContexts = computed(() => {
      return useUserSummary().filterContexts({
        limit: 9,
        filterFunc: c => c.status == 'active',
        sortBy: 'lastOpened'
      }).value;
    });

    const { sortedFolders } = useUserSummary();
    return { recentContexts, activeContexts, sortedFolders };
  }
};
</script>

<style></style>
